import { from, Observable, of, timer } from 'rxjs';
import { catchError, map, retry, switchMap } from 'rxjs/operators';

import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthenticationService } from '../../services/authentication/authentication.service';

export const AuthGuard: CanActivateFn = (): Observable<boolean> => {
  const router = inject(Router);
  const authenticationService = inject(AuthenticationService);

  // O app sobe sem esperar o keycloak.init() (so a volta do login segura o
  // bootstrap): sem esta espera, um F5 numa rota protegida leria isLoggedIn()
  // antes de a sessao existir e mandaria o usuario para /inicio.
  return from(authenticationService.aguardarInit()).pipe(
    map(() => authenticationService.isLoggedIn()),
    switchMap(isLoggedIn => {
      if (isLoggedIn) {
        return from(authenticationService.refreshTokenIfNeeded()).pipe(
          retry({
            count: 2,
            delay: () => timer(2000)
          }),
          map(() => authenticationService.getToken())
        );
      }
      return of(false);
    }),
    map(token => {
      if (!token) {
        router.navigate(['/inicio']);
        return false;
      }
      return true;
    }),
    catchError(() => {
      router.navigate(['/inicio']);
      return of(false);
    })
  );
};